import React from "react";
import styled from "styled-components";
import { Typography } from "@shared/ui/Typography";
import { ProgressBar } from "@shared/ui/ProgressBar";

interface IProps {
  step: string;
  title: string;
  percent: number;
  className?: string;
}

export function Stepper({ step, title, percent, className }: IProps) {
  return (
    <StyledView className={className}>
      <StyledHeader>
        <Typography fontSize="1.8rem" weight={500}>
          {step}
        </Typography>
        <Typography color="primary_light_gray">{title}</Typography>
      </StyledHeader>
      <ProgressBar percent={percent} />
    </StyledView>
  );
}

const StyledView = styled.div`
  display: grid;
  grid-gap: 2.4rem;
  align-content: flex-start;
`;

const StyledHeader = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 1.5rem;
  align-items: center;
  justify-content: flex-start;
`;
